<div class="container">
  <button
    click-stop-propagation
    class="adap-btn-grid-cell mapping"
    type="button"
    matTooltip="show mappings"
    matTooltipPosition="above"
    (click)="showMappings()"
    [disabled]="totalMappings == 0"
  >
    <span class="mapping-number">{{ totalMappings }}</span>
    <mat-icon class="mapping-icon">link</mat-icon>
  </button>
</div>
